import React from "react";

const DashboardSVG = ({ activeSvgColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 33 29"
      fill="none"
    >
      <path
        d="M31 2H2V11H31V2Z"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31 17H21V27H31V17Z"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.25 17.75H14.75"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="2.25"
        y1="21.75"
        x2="10.75"
        y2="21.75"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.25 25.75H6.75"
        stroke={activeSvgColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    // <svg
    //   width="19"
    //   height="19"
    //   viewBox="0 0 19 19"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M18.3243 7.79253H10.2502V1.95855L18.3243 0.620605V7.79253ZM18.3243 11.0297V18.1992L10.2502 16.8846V11.0297H18.3243ZM6.57362 7.78993H0V3.58358L6.57362 2.49441V7.78993ZM6.57362 11.0297V16.3558L0 15.2851V11.0297H6.57362Z"
    //     fill={activeSvgColor}
    //   />
    // </svg>
  );
};

export default DashboardSVG;
